import * as React from "react";
import {
  OutletContextProps,
  WithRouterProps,
} from "../../helpers/RouterHelper";
import enhanceSectionsSettingsPage from "../../hocs/enhanceSectionsSettingsPage";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionsSettingsAiAssistantTemplatesEdit from "./SectionsSettingsAiAssistantTemplatesEdit";

interface Props extends WithRouterProps<{ id: string }>, OutletContextProps {
  section: SectionInterface;
}

const SectionsSettingsAiAssistantTemplatesEditPage: React.FC<Props> = (
  props,
) => {
  React.useEffect(() => {
    props.setActiveMenu("template");
  }, []);

  return (
    <SectionsSettingsAiAssistantTemplatesEdit
      section={props.section}
      templateId={props.params.id}
    />
  );
};

const pageInfo = {
  title: "テンプレート",
};

export default enhanceSectionsSettingsPage(
  SectionsSettingsAiAssistantTemplatesEditPage,
  pageInfo,
);
